import { Helmet } from 'react-helmet';

export const GuestHeaderMetadata = () => {
  const title = `CRM  | welcome to Ticlick`;
  const description =
    'At Ticlick, we’re transforming student recruitment. Our advanced CRM platform is tailored for J1 Agencies, US Designated Sponsors, Study Abroad Agencies, Language Schools, Post-Secondary Institutions, Colleges, Universities, and Volunteering Organizations. We streamline operations, simplify tasks, and enhance student relationship management, making the recruitment process smart, quick, and easy.';
  const website = 'crm.ticlickcrm.com';

  return (
    <Helmet>
      <meta charSet='utf-8' />
      <title>{title}</title>
      <link
        rel='icon'
        type='image/svg+xml'
        href='/ticlick-logo.svg'
      />
      <link
        rel='canonical'
        href={website}
      />
      <meta
        name='description'
        content={description}
      />
    </Helmet>
  );
};
